import { createAsyncThunk } from '@reduxjs/toolkit'
import { tasksData } from '@assets/mockdata'
import { Task, UpdateTaskThunkParams } from '@dataTypes/index'

export const fetchAllTasks = createAsyncThunk(
  'tasks/fetchAllTasks',
  async () => {
    return tasksData
  },
)

export const addTask = createAsyncThunk('tasks/addTask', async (body: Task) => {
  return body
})

export const updateTask = createAsyncThunk(
  'tasks/updateCampaign',
  async (params: UpdateTaskThunkParams) => {
    const { id, body } = params
    return { id, body }
  },
)

export const removeTask = createAsyncThunk(
  'tasks/removeTask',
  async (index: string) => {
    return index
  },
)
